import { useFilterDisabledSettings } from "@api";
import { Autocomplete, TextField, autocompleteClasses } from "@mui/material";
import { useGlobalContext } from "@root/context";
import equal from "fast-deep-equal/react";
import { useEffect, useState } from "react";
import type { IAddParticipantFilters, IFilterInputProps } from "./types";

export const FilterCoachingStep = ({ value, dispatch }: IFilterInputProps<IAddParticipantFilters["coachingSteps"]>) => {
  const { settings } = useGlobalContext();

  const settingsCoachingStep = useFilterDisabledSettings(
    settings?.settingsCoachingStep ? settings.settingsCoachingStep : []
  );

  const [localValue, setLocalValue] = useState(value);

  const handleDispatch = () => {
    if (!equal(localValue, value)) {
      dispatch({ type: "coachingSteps", payload: localValue });
    }
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <Autocomplete
      multiple
      options={settingsCoachingStep}
      value={localValue}
      onBlur={handleDispatch}
      onChange={(_, coachingStep, reason) => {
        setLocalValue(coachingStep);
        if (reason === "removeOption") {
          dispatch({ type: "coachingSteps", payload: coachingStep });
        }
      }}
      fullWidth
      renderInput={(params) => <TextField {...params} label="Étape" size="small" />}
      limitTags={2}
      slotProps={{
        chip: {
          color: "yellow",
          size: "small",
          sx: { [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } },
        }
      }}
    />
  );
};
